module.exports = __webpack_public_path__ + "img/android.9977bb51.jpg";